import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';


@Component({
  selector: 'forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css']
 
})

export class ForbiddenComponent implements OnInit {
  
  
  constructor() {
   
  }

  ngOnInit() { 

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/forbidden/forbidden.component.ts